exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test-questions[data-v-9a4a7dc0]{width:1000px;margin:0 auto}", ""]);

// exports
